import type { Influencer } from '@/marketing/models/influencer';
import type { InfluencerVoucher, VoucherCandidate } from '@/marketing/models/voucher';

export interface BuildVoucherCandidatesParams {
  influencers: Influencer[];
  /** Codes already on file, used to mark creators who cannot be issued another one. */
  issuedVouchers: InfluencerVoucher[];
}

interface HandleIdentity {
  handle: string;
  platform: string;
}

/** Codes are held per social identity, and the two sides spell handles differently (@, case). */
export function voucherIdentityKey({ handle, platform }: HandleIdentity): string {
  return `${platform.trim().toLowerCase()}/${handle.trim().replace(/^@/, '').toLowerCase()}`;
}

export function buildVoucherCandidates({
  influencers,
  issuedVouchers,
}: BuildVoucherCandidatesParams): VoucherCandidate[] {
  const codesByIdentity = new Map(issuedVouchers.map((voucher) => [voucherIdentityKey(voucher), voucher.code]));

  return influencers.map((influencer) => ({
    influencerId: influencer.id,
    handle: influencer.handle,
    platform: influencer.platform,
    displayName: influencer.displayName,
    followersCount: influencer.followersCount,
    existingCode: codesByIdentity.get(voucherIdentityKey(influencer)) ?? null,
  }));
}
